import React from 'react';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import enGB from 'date-fns/locale/en-GB';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/pro-regular-svg-icons/faTimesCircle";

registerLocale('en-GB', enGB);
setDefaultLocale('en-GB');

export default ({ value, dateFormat, ...rest}) => (
    <div className="relative">
        <DatePicker
            autoComplete="off"
            selected={value}
            withPortal
            fixedHeight
            dateFormat={dateFormat || 'dd/MM/yyyy'}
            {...rest}
            className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
        />

        {value && (
            <button
                className="absolute right-3 inset-y-0 flex items-center transition duration-200 transform enabled:hover:scale-125"
                onClick={() => rest.onChange(null)}
                disabled={rest.disabled}
            >
                <FontAwesomeIcon
                    icon={faTimesCircle}
                    className="text-gray-500"
                />
            </button>
        )}
    </div>
);
